// =============================================================================
// FILE:
// frontend/src/ipe/pms/services/materialMovementLedgerService.js
// =============================================================================

import axiosClient
  from "../../../api/axiosClient";

// =============================================================================
// GET MATERIAL MOVEMENT LEDGER
// =============================================================================

export const getMaterialMovementLedger =
  async (payload) => {

    const response =
      await axiosClient.post(

        "/api/pms/material-movement-ledger/list",

        payload
      );

    return response.data;
  };